/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */
import { BlankEnum } from './blankEnum';
import { UnitOfMeasure } from './unitOfMeasure';

export const SimpleMaterialComponentUnit = {...UnitOfMeasure,...BlankEnum,} as const